// toastr options
export const TOASTR_OPTIONS = {
  timeOut: 10000,
};
